import React from "react";
import { Box, Button } from "@mui/material";
import ActionFooter from "../../../Shared/ActionFooter/ActionFooter";

const NewInspectionNative = (props: any) => {
  const { goToNewInspectionPlate } = props;

  return (
    <Box component="div" className="inspection">
      <div className="title">Informe a placa do veículo</div>
      <div className="description">
        Tire uma foto da placa do veículo ou<br />clique em “Digitar placa” para inserir<br />manualmente.
      </div>
      <ActionFooter>
        <Button
          fullWidth
          variant="outlined"
          className="secondary-button"
          onClick={goToNewInspectionPlate}
        >Digitar placa</Button>
      </ActionFooter>
    </Box>
  )
};

export default NewInspectionNative;
